<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="PRODUCT_CATEGORY_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="productCategoryCd"
            label="품목유형"
            v-model="searchParam.productCategoryCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="규제항목별 화학자재 수량"
          tableId="riskHazrd01"
          :columns="grid.columns"
          :data="grid.data"
          :hideBottom="true"
          :columnSetting="false"
          :usePaging="false"
          :filtering="false"
          gridHeight="300px"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="props.row[col.name] != 0">
              <div class="tdBackGroundColor">
                {{ props.row[col.name] }}
              </div>
            </template>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'chem-manage-count',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        plantCd: null,
        useFlag: 'Y',
        productCategoryCd: null,
        headerType: 'countlaw',
      }),
    },
  },
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      searchParam: {
        plantCd: null,
        useFlag: '',
        mdmChemMaterialId: '',
        materialName: '',
        regulatedItemCd: [],
        searchItems: [],
        headerType: 'countlaw',
        limLicenseKindId: '',
        limLicenseKindName: '',
        productCategoryCd: null,
      },
      grid: {
        columns: [
          {
            name: 'usCnt',
            field: 'usCnt',
            label: '미국',
            headType: 'flag',
            lang: 'US',
            setHeader: true,
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'euCnt',
            field: 'euCnt',
            label: '유럽',
            setHeader: true,
            headType: 'flag',
            lang: 'EU',
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'cnCnt',
            field: 'cnCnt',
            label: '중국',
            headType: 'flag',
            lang: 'CN',
            setHeader: true,
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'jpCnt',
            field: 'jpCnt',
            label: '일본',
            headType: 'flag',
            lang: 'JP',
            setHeader: true,
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'vnCnt',
            field: 'vnCnt',
            label: '베트남',
            headType: 'flag',
            lang: 'VN',
            setHeader: true,
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
          {
            name: 'clCnt',
            field: 'clCnt',
            label: '칠레',
            headType: 'flag',
            lang: 'CL',
            setHeader: true,
            align: 'center',
            type: 'custom',
            style: 'width:60px',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      headerUrl: '',
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.headerUrl = selectConfig.mdm.mam.chem.header.url;
    this.getHeader();
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.mdm.mam.chem.listreg.url + '/count';
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;

      this.searchParam.plantCd = this.popupParam.plantCd;
      this.searchParam.useFlag = this.popupParam.useFlag;
      this.searchParam.productCategoryCd = this.popupParam.productCategoryCd;
      this.searchParam.headerType = this.popupParam.headerType;

      this.getList();
    },
    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
          this.grid.columns.push(_item);
        })
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
  }
};
</script>

<style scoped>
.tdBackGroundColor {
  display: inline-block;
  width: 30px;
  height: 25px;
  background: #26a69a;
  border-radius: 10px;
  color: #fff;
  font-weight: 700;
  padding-top:2px;
}
</style>